import { CloseOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'components/ui/button';

export type FilterChipProps = Omit<ButtonProps, 'variant' | 'selected'> & {
  selected: boolean;
  /** How many items the filter matches, after its name. */
  count?: number;
  /** Whether the selected chip shows the cross that removes it (not « Toutes », which only clears the others). */
  removable?: boolean;
};

/**
 * A filter of a list (the themes of a content category, the specialties of
 * the team page). The selected chip reads as an active filter, with a cross to
 * remove it.
 */
export default function FilterChip({ selected, count, removable = true, children, ...props }: FilterChipProps) {
  return (
    <Button variant={selected ? 'default' : 'outline'} selected={selected} {...props}>
      {children}
      {count !== undefined && <small className="font-normal">{count}</small>}
      {selected && removable && <CloseOutlined />}
    </Button>
  );
}
